<template>

  <div v-if="singleJourneyDetail!=null" class="createNewJourneyContent">
    <v-container class="mt-12 pt-12 mb-0 pb-0 px-0">

      <v-row class="mt-0 pt-0 mb-0 pb-0 px-4">
        <v-btn v-if="singleJourneyDetail.user.id===getUser.id" :style="{position: 'fixed',bottom: '0vh',left:'5vw',transform:'translateY(-50%)'}" absolute bottom left fab color=white
          @click="deleteJourney()">
          <v-icon>mdi-delete-outline</v-icon>
        </v-btn>
        <v-btn v-if="singleJourneyDetail.user.id===getUser.id" :style="{position: 'fixed',bottom: '0vh',right:'5vw', transform:'translateY(-50%)'}" absolute bottom right fab color=primary
          @click="editJourney()">
          <i class="mdi mdi-square-edit-outline"></i>
        </v-btn>
        <v-col cols="10" class="mt-0 pt-0 mb-2 pb-4">
          <h2>{{singleJourneyDetail.journeyTitle}}</h2>
        </v-col>
        <v-col cols="1" class="mt-0 pt-0 mb-0 pb-0">
          <v-btn v-if="this.$route.query.idJourney==$store.getters.getBookmark" fab dark
            @click="removeJournayInLocalStorage($route.query.idJourney)" color=primary>
            <v-icon>mdi-bookmark-remove</v-icon>
          </v-btn>
          <v-btn v-else fab icon @click="saveJournayInLocalStorage($route.query.idJourney)">
            <v-icon color=primary>mdi-bookmark-plus-outline</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="1" class="mt-0 pt-0 mb-0 pb-0">
        </v-col>
      </v-row>
      <v-row class="mt-0 pt-0 mb-0 pb-0 px-4">
        <v-col cols="12" class="mt-0 pt-0 mb-2 pb-4">
        </v-col>
        <v-col cols="12" class="mt-0 pt-0 mb-2 pb-4">
          <p class="journeyDescription">{{singleJourneyDetail.journeyDescription}}</p>
        </v-col>
      </v-row>
      <v-row class="mt-0 pt-0 mb-0 pb-0 px-4">
        <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">
          <v-radio-group class="switch-field3" v-model="isJourneyListOrMapview" row background-color="white"
            active-class="active3">
            <v-radio id="radio-five" name="switch-three" :label="$t('list')" :value="0"></v-radio>
            <v-radio id="radio-six" name="switch-four" :label="$t('map')" :value="1"></v-radio>
          </v-radio-group>

        </v-col>
      </v-row>

      <!-- List of stories-->
      <v-row :style="calcoulateBackgroundColor" class="mt-0 pt-0 mb-0 pb-0 px-4" v-if="isJourneyListOrMapview==0">
        <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">
          <v-row>
            <v-col>
              <v-container v-for="(item,counter) in singleJourneyDetail.storiesArrayObjectIdDescription" :key="item.id">
                <h2 class="line-divider "><span class="span-line-divider ">

                    <v-avatar class="white--text" color="primary" size="50">
                      <h5 class="white--text">{{counter+1}}</h5>
                    </v-avatar>

                  </span></h2>
                <v-row align="center" justify="center">

                  <v-col cols=3>


                  </v-col>
                </v-row>

                <v-row align="center" justify="center">
                </v-row>
                <v-row class="descriptionStoryJourney">
                  {{item.descriptionStoryJourney}}
                </v-row>

                <v-row>
                  <v-col  @click="openSingleStoryDetail(item.id)" class="px-0 pt-0 pb-0 mt-0 mx-0 mb-0" col=12>
                    <template v-if="item.cover_image!=null">
                      <mediaFileStory
                        v-if="!$vuetify.breakpoint.mdAndUp&&item.cover_image.media.formats.hasOwnProperty('coverImageCenter')"
                        :mediaUrl="apiStrapi + item.cover_image.media.formats.coverImageCenter.url.replace(/ /g, '%20')"
                        type="image" :isLocal="false" :storyTitle="item.title">
                      </mediaFileStory>
                      <mediaFileStory
                        v-else-if="!$vuetify.breakpoint.mdAndUp&&item.cover_image.media.formats.hasOwnProperty('large')"
                        :mediaUrl="apiStrapi + item.cover_image.media.formats.large.url.replace(/ /g, '%20')"
                        type="image" :isLocal="false" :storyTitle="item.title">
                      </mediaFileStory>
                      <mediaFileStory
                        v-else-if="!$vuetify.breakpoint.mdAndDown&&item.cover_image.media.formats.hasOwnProperty('medium')"
                        :mediaUrl="apiStrapi + item.cover_image.media.formats.medium.url.replace(/ /g, '%20')"
                        type="image" :isLocal="false" :storyTitle="item.title">
                      </mediaFileStory>
                      <mediaFileStory
                        v-else-if="!$vuetify.breakpoint.mdAndDown&&item.cover_image.media.formats.hasOwnProperty('small')"
                        :mediaUrl="apiStrapi + item.cover_image.media.formats.small.url.replace(/ /g, '%20')"
                        type="image" :isLocal="false" :storyTitle="item.title">
                      </mediaFileStory>
                      <mediaFileStory v-else
                        :mediaUrl="apiStrapi + item.cover_image.media.formats.thumbnail.url.replace(/ /g, '%20')"
                        type="image" :storyTitle="item.titleStory" :isLocal="false">
                      </mediaFileStory>
                    </template>

                  </v-col>
                </v-row>
<v-row mt-0 pt-0>
                <v-container @click="openSingleStoryDetail(item.id)" class="mt-0 pt-0 px-2" style="background-color:white">
                <v-row align="center" class="mt-0 pt-0 px-2">
                  <v-col cols=10>
                    <v-row >
                      <h2>{{item.title}}</h2>
                    </v-row>

                  </v-col>
                  <v-col cols=2>
                    <a v-if="getUserCoordinates" target="_blank" :href="'https://www.google.com/maps/dir/?api=1&origin='+getUserCoordinates.lat+','+ getUserCoordinates.lng+ '&destination='+item.latitude+','+item.longitude+'&travelmode=walking'">
                                    <v-icon style="transform: rotate(-90deg)" color="black">mdi-arrow-down-right-bold</v-icon>
                    </a>

                  </v-col>
                </v-row>
                <v-row class="mt-0 pt-0 px-2">
                  {{item.user.username}}

                </v-row>
              </v-container>
</v-row>
              </v-container>

            </v-col>
          </v-row>
          <v-row class="mt-0 pt-0 mb-0 pb-0 px-4" v-if="isJourneyListOrMapview==0">
            <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">


            </v-col>
          </v-row>

        </v-col>
      </v-row>
      <v-row class="mt-0 pt-0 mb-0 pb-0 px-4" v-else>
        <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">

          <l-map ref="leafletmap" if="showMap" :zoom="zoom" :center="center" :options="mapOptions"
            style="height: 60vh;z-index:2;">


            <l-tile-layer :url="url" />
            <template v-if="singleJourneyDetail.isJourney">
              <l-polyline v-for="(item,i) in connectionLine" :key="'A'+i" :dashArray="item.dasharray"
                :lat-lngs="item.line" :color="item.color"></l-polyline>
            </template>

            <l-marker v-for="(item,counter) in singleJourneyDetail.storiesArrayObjectIdDescription" :key="item.id"
              :zIndexOffset="100" :lat-lng="{lat:item.latitude,lng:item.longitude}">

              <l-icon :iconSize="[20, 20]" :iconAnchor="[10, 10]">
                <v-avatar v-if="singleJourneyDetail.isJourney"
                  :color="'colorPalettejourney'+singleJourneyDetail.backgroundColor" class="white--text" size="20">
                  {{counter+1}}
                </v-avatar>
                <mediaFileStory v-else :journeyBackgroundColor="singleJourneyDetail.backgroundColor"
                  :isMapRoundImg="true" :isKGimage="true" :isPlaceholder="false"
                  :mediaUrl="apiStrapi +'/uploads/'+ item.cover_image.media.formats.thumbnail.hash+item.cover_image.media.formats.thumbnail.ext"
                  :type="item.cover_image.type" :isLocal="false" :isThumbnail="false" />
              </l-icon>
            </l-marker>

            <l-marker v-if="center.lng !=null && center.lat!=null" :lat-lng="center">
              <l-icon :con-size="[1,1]">
                <img style="width:5vh" :src="require('@/assets/account.png')" />
              </l-icon>
            </l-marker>

          </l-map>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
//import singleJourneyView from '@/mockData/singleJourneyView.json'

import mediaFileStory from "@/components/mediaFileStory.vue";
import {
  latLng
} from "leaflet";
import {
  LPolyline,
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  //LControl
} from "vue2-leaflet";

export default {
  name: "singleJourneyView",
  data: () => ({
    connectionLine: [],
    singleJourneyDetail: null,
    apiUrl: process.env.VUE_APP_ROOT_API,
    apiStrapi: process.env.VUE_APP_ROOT_STRAPI,
    getUserCoordinates: null,
    isJourneyListOrMapview: 0,
    zoom: 10,
    center: latLng(44.8377720, 11.6186548),
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    currentZoom: 11.5,
    mapOptions: {
      zoomSnap: 0.5
    }

  }),

  async mounted() {
    //check the current position of the user (for now it is associated with the user logged in the db)
    this.getUserCoordinates=null
    this.$getLocation()
      .then(response => {
        this.getUserCoordinates = response
        if (this.getUserCoordinates != null) {
          this.center = {
            lat: this.getUserCoordinates.lat,
            lng: this.getUserCoordinates.lng
          }
        }
      });

    this.center = {
      lat: this.$store.getters.getUser.latitude,
      lng: this.$store.getters.getUser.longitude
    }

    this.getSingleJourney().then(() => this.writelines())


  },
  methods: {
    editJourney: function () {
      this.$store.dispatch("clearNewStory").then(() => {
        this.$router.push({
          name: 'createNewJourneyContent',
          query: {
            idJourney: this.$route.query.idJourney
          }
        })
      })
    },
    async deleteJourney() {
      try {
        //console.log("getSingleStory")

        this.$store.dispatch('setLoading', true)
        let completeurl = this.apiUrl + '/deleteJourney?id=' + this.$route.query.idJourney
        let response
        response = await this.$axios.delete(completeurl, {
          headers: {
            "x-access-token": `Bearer ${this.$store.getters.getAccessToken}`,
            'Content-Type': 'multipart/form-data',
          }
        }).then(response => {
          if (response.status === 200) {
//            this.$store.dispatch("setIsJourneyOrSingleStory", true)
//            this.$store.dispatch("setIsJourneyOrSingleStory", true)
//            this.$store.dispatch('setIsCreatedOrviewJourneys', 1)
//            this.$store.dispatch('setIsAllOrNearmeJourneys', 0)
            this.$router.push({
              'name': 'home'
            })
          }
        })
        if (typeof response.content == "string") {
          response.content = JSON.parse(response.content)
        }
        console.log("delete response", response.data)

        this.$store.dispatch('setLoading', false)

      } catch (error) {
        console.log(error);
        this.$router.push({
          name: 'errorPage'
        })
      }
    },
    writelines() {


      this.singleJourneyDetail.storiesArrayObjectIdDescription.forEach((element, index) => {
          if (typeof this.singleJourneyDetail.storiesArrayObjectIdDescription[index + 1] != 'undefined') {
            this.connectionLine.push({
              line: [latLng(element.latitude, element.longitude), latLng(this.singleJourneyDetail.storiesArrayObjectIdDescription[index + 1].latitude, this.singleJourneyDetail.storiesArrayObjectIdDescription[index + 1].longitude)],
              color: this.calcoulateLineColor,
              weight: 2,
              opacity: 0.5,
              smoothFactor: 1
            })
          }
        }

      )

    },
        openSingleStoryDetail: function (idOfSelectedStory) {
          console.log(idOfSelectedStory,'openSingleStoryDetail')
        this.$router.push({
                'name': 'carouselForSingleStoryView',query: { idStory: idOfSelectedStory }
              })
    },
    async getSingleJourney() {
      try {
        this.$store.dispatch('setLoading', true)
        let completeurl = this.apiUrl + '/getJourney?id=' + this.$route.query.idJourney
        let tempSingleStoryDetail
        tempSingleStoryDetail = await this.getaxiosResponse(completeurl)
        if (typeof tempSingleStoryDetail.content == "string") {
          tempSingleStoryDetail.content = JSON.parse(tempSingleStoryDetail.content)
        }
        this.singleJourneyDetail = tempSingleStoryDetail.data

        this.$store.dispatch('setLoading', false)
        if (tempSingleStoryDetail == null) {
          console.log('you do not have the correct credentials to view the story')
          this.$router.push({
            name: 'errorPage'
          })
        }
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: 'errorPage'
        })
      }
    },
    saveJournayInLocalStorage(value) {
      this.$store.dispatch("setBookmark", value).then(()=>
            this.$store.dispatch("setSnackbar", {
            color: 'success',
            text: this.$i18n.t('journeyAddedToFavorites'),
            active: true
          }))
    },
    removeJournayInLocalStorage() {
      this.$store.dispatch("setBookmark", null).then(()=>
            this.$store.dispatch("setSnackbar", {
            color: 'error',
            text: this.$i18n.t('journeyRemovedToFavorites'),
            active: true
          }))
    }
  },
  computed: {
    getUser: {
      get: function () {
        return this.$store.getters.getUser;
      }
    },
    calcoulateLineColor: {

      get: function () {
        if (this.singleJourneyDetail.backgroundColor == 1) {
          return this.$vuetify.theme.themes.light.colorPalettejourney1
        } else if (this.singleJourneyDetail.backgroundColor == 2) {
          return this.$vuetify.theme.themes.light.colorPalettejourney2
        } else if (this.singleJourneyDetail.backgroundColor == 3) {
          return this.$vuetify.theme.themes.light.colorPalettejourney3
        } else if (this.singleJourneyDetail.backgroundColor == 4) {
          return this.$vuetify.theme.themes.light.colorPalettejourney4
        } else if (this.singleJourneyDetail.backgroundColor == 5) {
          return this.$vuetify.theme.themes.light.colorPalettejourney5
        } else if (this.singleJourneyDetail.backgroundColor == 6) {
          return this.$vuetify.theme.themes.light.colorPalettejourney6
        } else
          return 'grey'
      }
    },
    calcoulateBackgroundColor: {

      get: function () {
        if (this.singleJourneyDetail.backgroundColor == 1) {

          return 'background: linear-gradient(' + this.$vuetify.theme.themes.light.colorPalettejourneylight1 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark1 + ')'
        } else if (this.singleJourneyDetail.backgroundColor == 2) {
          return 'background: linear-gradient(' + this.$vuetify.theme.themes.light.colorPalettejourneylight2 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark2 + ')'
        } else if (this.singleJourneyDetail.backgroundColor == 3) {
          return 'background: linear-gradient(' + this.$vuetify.theme.themes.light.colorPalettejourneylight3 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark3 + ')'
        } else if (this.singleJourneyDetail.backgroundColor == 4) {
          return 'background: linear-gradient(' + this.$vuetify.theme.themes.light.colorPalettejourneylight4 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark4 + ')'
        } else if (this.singleJourneyDetail.backgroundColor == 5) {
          return 'background: linear-gradient(' + this.$vuetify.theme.themes.light.colorPalettejourneylight5 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark5 + ')'
        } else if (this.singleJourneyDetail.backgroundColor == 6) {
          return 'background: linear-gradient(' + this.$vuetify.theme.themes.light.colorPalettejourneylight6 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark6 + ')'
        } else
          return ''
      }
    }

  },
  components: {
    mediaFileStory,
    LPolyline,
    LMap,
    LTileLayer,
    LMarker,
    LIcon
    //LControl
  },

}
</script>
<style scope>
.descriptionStoryJourney{
  margin-bottom: 2vh;
  text-transform: initial;
}
.center-number {
  margin-top:0px!important;
  margin-bottom: 0px!important;
}

hr.icon {
margin: 25px auto 30px;
padding: 0;
border: 0;
border-top: solid 3px;
text-align: center;
}

hr.icon:after {
/*content: "7";*/
display: inline-block;
position: relative;
top: -1rem;
padding: 0 1rem;
font-size: 3rem;
background-color: primary;
}

/*toggle button list - map */


.v-input--selection-controls {
    padding-top: 0px !important;
}
.v-input.switch-field2.theme--light.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row > div > div.v-input__slot > div,
.v-input.switch-field3.theme--light.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row > div > div.v-input__slot > div{
  background-color: #e5e5e5;
  border-radius: 99rem;
}

.v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
}
.v-input__slot{
  margin-bottom: 0px;
}
/* v-radio btn 1*/
.theme--light.v-label{
  color: black;
}

.v-input--radio-group.v-input--radio-group--row .v-radio {
    margin-right: auto;
    margin-left: auto;
    width: 48%;
    text-align: center;
}
.v-input--radio-group.v-input--radio-group--row .v-radio > .v-label{
  padding: auto auto;
  text-align: center;
}

.active2,.active3{
  background-color: #38737A;
  border-radius: 999rem;
}
div.v-radio.theme--light.active3 > label,div.v-radio.theme--light.active2 > label{
    color: white!important;
}
.switch-field1.v-input--radio-group.v-input--radio-group--row .v-radio{
  margin-right: auto;
  margin-left: auto;

}
.switch-field2.v-input--radio-group.v-input--radio-group--row .v-radio{
  margin-right: auto;
  margin-left: auto;
  padding: 0px 5vh;

}
.switch-field3.v-input--radio-group.v-input--radio-group--row .v-radio{
  margin-right: auto;
  margin-left: auto;
  padding: 0px 5vh;

}
.v-input.switch-field1.theme--light.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row > div > div.v-input__slot.white > div > div.v-radio.theme--light > div{
  display: none;
}
.v-application--is-ltr .v-input--selection-controls__input {
    display: none;
}

/* end v-radio btn */
.v-tab--disabled {
    pointer-events: none;
    opacity: 1;
}
.v-btn--fab.v-size--x-large {
    height: 100px;
    width: 100px;
}
.rounded-circle{
  border-radius: 50%;
  padding: 10%;
}
.rounded-circle span{
white-space: inherit;
}
.w3-badge{
  border-radius: 50%;
    background-color: gray;
    color: #fff;
    display: inline-block;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    text-align: center;
    line-height: 1.5rem;
}
.border-bottom-grey{
  border-bottom: 1px solid gray;
}

.v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
  justify-content: center
}
.switch-field3,.switch-field2 {

	color: rgba(0, 0, 0, 0.6);
	display: flex;

	overflow: hidden;
}

.switch-field3 input,.switch-field2 input {
	position: absolute !important;
	clip: rect(0, 0, 0, 0);
	height: 1px;
	width: 1px;
	border: 0;
	overflow: hidden;
}

.switch-field3 label,.switch-field2 label {
  width: 50%;

	/*background-color: #e5e5e5;
	color: rgba(0, 0, 0, 0.6);*/
	font-size: 14px;
	line-height: 1;
	text-align: center;
	padding: 4px 0px;
	/*border: 1px solid rgba(0, 0, 0, 0.2);*/
	/*box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1);*/
	transition: all 0.1s ease-in-out;
}

.switch-field3 label:hover,.switch-field2 label:hover {
	cursor: pointer;
}

.switch-field3 input:checked + label,.switch-field2 input:checked + label {
	background-color: #000;
  color:#FFF;
  border-radius: 99rem;
	box-shadow: none;
}

.switch-field3 label:first-of-type,.switch-field2 label:first-of-type {
	border-radius: 4px 0 0 4px;
}

.v-radio.theme--light > label{
  margin-left: auto;
  margin-right: auto;
}
.theme--light.v-label{
  color: #38737A;
}


/**line delimiter */



  .container-80 {
                            width: 80%;
                            max-width: 960px;
                            margin: 0 auto;
                            padding-top: 50px;
                            height: 100%;
                        }
                        
                        .style-gris {
                            font: bold 400% "Open Sans", Arial, sans-serif;
                            color: #777;
                            text-align: center;
                        }
                        
                        .line-divider {
                            margin-top: 10px;
                            font: 150% "Open Sans", Arial, sans-serif;
                            color: #999;
                            text-align: center;
                            position: relative;
                            margin-bottom: 2%;
                        }
                        
                        .line-divider:before {
                            content: "";
                            display: block;
                            border-top: solid 2px #999;
                            width: 100%;
                            height: 2px;
                            position: absolute;
                            top: 17px;
                            z-index: 1;
                        }

                        .line-divider .span-line-divider {

                            padding: 0;
                            position: relative;
                            z-index: 5;
                        }
                        .margin-bottom-20px {
                            margin-bottom: 20px;
                        }
</style>
